import { ANALYTICS_EVENT } from './const';
import {
  TAnaliticProps,
  TAnaliticCustomParams
} from './types';

export const sendOldmaAnalyticsEvent = ({
  id,
  name,
  customParams = {}
}: TAnaliticProps) => {
  try {
    const dataLayer = window.dataLayer;
    const isAbleToPush =
      dataLayer &&
      typeof dataLayer.push === 'function' &&
      id &&
      name;
    const isDevelopment =
      process.env.NODE_ENV === 'development';
    const params: TAnaliticCustomParams = {};
    const collectParams = () => {
      params.event = ANALYTICS_EVENT;
      params.event_id = id;
      params.event_name = name;

      if (customParams) {
        for (const [key, value] of Object.entries(
          customParams
        )) {
          params[key] =
            typeof value === 'string'
              ? value
              : JSON.stringify(value);
        }
      }
    };

    if (isAbleToPush || isDevelopment) {
      collectParams();
    }

    if (isDevelopment) {
      console.log(params); // eslint-disable-line
    }

    if (isAbleToPush) {
      dataLayer.push(params);
    }
  } catch (error) {
    // TODO: добавить сборщик ошибок, когда появиться
  }
};
